import { Component, Input } from '@angular/core';

@Component({
    selector: 'ins-insurances-dropdown',
    templateUrl: './insurances-dropdown.component.html',
})

export class InsurancesDropdownComponent {
    @Input() arrowRight: boolean = false;
    @Input() arrowText: string = 'Kies een verzekering';
}
